import { desktop, media, tablet, themeColors, transitionTime } from '@hg/stylizator/utils'
import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`
    .d-none {
      display: none !important;
    }
    
    .m-0 {
        margin: 0 !important;
    }

    button > * {
      pointer-events: none;
    }

    .ajax-loader {
      display: block !important;
    }

    .wp-block-columns {
        display: flex;
        margin-bottom: 0;
        flex-wrap: wrap;
    }

    .wp-block-columns.has-3-columns .wp-block-column {
      margin-bottom: 24px;
    }
    .wp-block-columns.has-3-columns {
      margin-bottom: 0;
    }
    
    @media ${media.tablet}, ${media.mobile} {
       .wp-block-columns.has-3-columns {
            flex-wrap: wrap;
            
            .wp-block-column {
              flex-basis: 100%!important;
              margin-left: 0;
            }
        }
    }
    
    .wpg-block.wpg-b_paragraph, .wpg-block.wpg-b_list {
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
    }
    
    .wp-block-table {
      table {
        border-collapse: collapse;
        
        td {
          border: 1px solid;
        }
      }
    }
    
      abbr[title='required'] {
    display: none;
  }

  label {
    display: block;
    font-weight: 500;
    font-size: 16px;
    line-height: 32px;
    color: ${themeColors.gray['90']};
  }

  .cwp-field-set {
    margin-bottom: 24px;
  }

  input {
    height: 48px;
  }
   
  textarea {
    min-height: 192px;
  }

  input, textarea {
    width: 100%;
    background-color: ${themeColors.gray['5']};
    border: 1px solid ${themeColors.gray['30']}!important;
    border-radius: 8px;
    padding: 0 16px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    box-sizing: border-box;

    &:hover {
      border: 1px solid ${themeColors.gray['40']}!important;
    }

    &:active {
      background: #ffffff;
      border: 1px solid ${themeColors.blue['50']};
    }

    &:focus {
      background: #ffffff;
      box-shadow: 0 0 0 4px ${themeColors.blue['30']};
      outline: none;
    }
  }
  
  input[type="submit"] {
    border-color: transparent !important;
    cursor: pointer;
    width: 256px;
    height: 48px;
    font-size: 16px;
    border-radius: 8px;
    background-color: ${themeColors.blue['60']};
    color: white;
    transition: ${transitionTime}s;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  
    &:hover {
      background-color: ${themeColors.blue['50']};
    }
  
    &:active {
      background-color: ${themeColors.blue['70']};
    }
  
    &:focus {
      box-shadow: 0 0 0 4px ${themeColors.blue['30']};
      outline: none;
    }
  }
  
  .wpcf7-response-output {
    color: #59A00D;
    border-color: transparent!important;
    text-align: center;
  }
  
  .wpcf7-form.invalid .wpcf7-response-output {
    color: #DA003E;
  }
  
  .wp-block-image {
    margin: 0 !important;
  }
  
  .hg-image-scalable img {
    min-width: 500px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    width: auto;
    display: inherit;
  }
  
  .hg-image-scalable.hg-image-scalable-large img {
    min-width: 800px;
  }
  
  .hg-image-scalable.hg-height-auto img {
    height: auto;
  }

  .hg-image-scalable.hg-image-without-bottom img {
    position: relative;
    top: 1px;
  }

  .hg-image-scalable.hg-image-without-bottom.hg-image-overflowing {
    overflow: hidden;
  }
  
  .wpcf7-form { 
    .input-with-submit {
      padding: 4px;
      position: relative;
    
      br {
        display: none;
      }
      
      .ajax-loader {
        position: absolute;
      }
      
      .icon {
        position: absolute;
        left: 28px;
        transform: translateY(-50%);
        top: calc(50% - 7px);
        
        @media (max-width: 576px) { 
          top: 36px;
        }
      }

      .wpcf7-form-control-wrap {
        position: initial;
        display: block;
        height: 80px;
      
        input {
          padding: 20px 164px 20px 58px;
          outline: 0;
          width: 100%;
          height: 64px;
          background: #F9FBFD;
          border: 1px solid #CED7E0;
          border-radius: 8px;
          
          @media (max-width: 576px) { 
            padding: 20px 20px 20px 58px;
          }
        }
      }
      
      input[type="submit"] {
        position: absolute;
        width: 148px;
        height: 48px;
        right: 12px;
        top: 12px;
        left: initial;
        transform: initial;
        
        @media (max-width: 576px) { 
          margin-top: 16px;
          width: 100%;
          transform: none;
          position: relative;
          right: initial;
          top: initial;
          left: initial;
        }
      }
    }
    
    &.invalid {
      .input-with-submit .icon {
        @media (max-width: 576px) { 
          top: calc(50% - 40px);
        }
      }
    }

    .wpcf7-checkbox {
      display: flex;
      flex-direction: column;
    }

    .wpcf7-checkbox .wpcf7-list-item label {
      display: flex !important;
      align-items: center;
      gap: 8px;
      line-height: 1;
    }

    .wpcf7-checkbox .wpcf7-list-item input {
      width: auto !important;
    }
  }
  
  .cf7-success {
    @media (max-width: 781px) {
      flex-basis: initial;
      flex-wrap: nowrap;
      
      .wp-block-column {
        flex-basis: initial !important;
      }
      .wp-block-column:nth-child(2n) {
        margin-left: 32px;
      }
    }
  }

  .max-height-initial {
    max-height: initial !important;
  }

  .min-height-800px {
    min-height: 800px;
  }

  @media ${tablet} {
    .tablet-padding-top-72px {
      padding-top: 72px;
    }
  }
`

export default GlobalStyles
